/**
 * Editor tooling: Alt+Shift+click on any element with a `data-solr-id`
 * attribute copies that ID to the clipboard. The two-modifier gesture is
 * deliberately awkward to avoid accidental triggers.
 * Restricted to internal users (aschehoug/universitetsforlaget)
 * to avoid confusion for external users.
 */
export function useEditorCopySolrId() {
  const toast = getToast()
  const isInternal = useIsInternal()

  function onClick(event: MouseEvent) {
    if (!isInternal.value) {
      return
    }
    if (!event.altKey || !event.shiftKey) {
      return
    }

    const target = event.target as Element | null
    const el = target?.closest?.('[data-solr-id]') ?? null
    if (!el) {
      return
    }

    const solrId = el.getAttribute('data-solr-id')
    if (!solrId) {
      return
    }

    event.preventDefault()
    event.stopPropagation()

    navigator.clipboard?.writeText(solrId)
      .then(() => toast.success(`ID kopiert: ${solrId}`))
      .catch(() => toast.error('Kunne ikke kopiere ID'))
  }

  onMounted(() => {
    document.addEventListener('click', onClick, true)
  })

  onBeforeUnmount(() => {
    document.removeEventListener('click', onClick, true)
  })
}
